// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"292233c7","239":"000d3dbe","455":"c352ffac"}[chunkId] + ".chunk.js";
};